import React from 'react';
import { Card, Button, Tag, Avatar } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    CopyOutlined,
    FileTextOutlined
} from "@ant-design/icons";
import { cn } from "../../../../utils/cn";

const EnhancedAutorespondersGridView = ({
    record,
    actions = [],
    onCardClick = () => { }
}) => {
    // Filter actions based on conditions
    const filteredActions = actions
        .map((action) => {
            if (action.condition && !action.condition(record)) {
                return null;
            }
            return action;
        })
        .filter(Boolean);

    const getAvatarContent = () => {
        return <FileTextOutlined />;
    };

    return (
        <Card
            hoverable
            className="h-full cursor-pointer relative"
            onClick={onCardClick}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className="flex-shrink-0 font-semibold text-base sm:text-lg !bg-primary sm:w-12 sm:h-12"
                            icon={getAvatarContent()}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate text-primary">
                                {record.name || "N/A"}
                            </h3>
                            <Tag color="cyan" className="text-[10px] sm:text-xs px-1.5 py-0.5 m-0 uppercase font-medium">Autoresponder</Tag>
                        </div>
                    </div>
                </div>

                {/* Info */}
                <div className="space-y-1.5 sm:space-y-2 border-b border-gray-200 pb-2 sm:pb-3">
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <span className="truncate font-semibold">
                            Title: <span className="text-gray-800 font-normal">{record.title || "No Title"}</span>
                        </span>
                    </div>
                </div>

                {/* Message Preview */}
                <div className="space-y-1">
                    <span className="text-[10px] sm:text-xs text-gray-400 font-semibold uppercase tracking-wider">Message Preview</span>
                    <div
                        className="text-xs sm:text-sm text-gray-600 line-clamp-2"
                        dangerouslySetInnerHTML={{ __html: record.message }}
                    />
                </div>

                {/* Action Buttons */}
                {filteredActions.length > 0 && (
                    <div
                        className={cn(
                            "grid sm:grid-cols-3 grid-cols-1 gap-1.5 sm:gap-2 pt-2 sm:pt-3 border-t border-gray-200",
                            filteredActions.length === 1 && "flex justify-end"
                        )}
                    >
                        {filteredActions.map((action, idx) => (
                            <Button
                                key={idx}
                                title={action.title ?? action.label}
                                className={cn(
                                    "text-xs sm:text-sm font-medium h-8 sm:h-9 my-0.5 sm:my-1 !border-primary !text-primary hover:!bg-primary hover:!text-white !min-w-full flex justify-center items-center transition-colors duration-150 ease-in-out",
                                    action.className
                                )}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick(record);
                                }}
                            >
                                {action.icon &&
                                    React.cloneElement(action.icon, { className: "mr-1 sm:mr-2 text-xs sm:text-sm" })}
                                {action.label}
                            </Button>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default EnhancedAutorespondersGridView;
